<div class="contains-button">

  <!-- <div style="display: flex; align-items: center; gap: 4px; flex-wrap: wrap;">
    <button [ngClass]="configMode == 'basic' ? 'ant-btn ant-btn-primary' : 'ant-btn'" class="d-flex align-items-center" (click)="configMode = 'basic'">
      <span>{{('cau_hinh_co_ban') | translate}}</span>
    </button>
  
    <button [ngClass]="configMode == 'advanced' ? 'ant-btn ant-btn-primary' : 'ant-btn'" class="d-flex align-items-center" (click)="configMode = 'advanced'">
      <span>{{('cau_hinh_nang_cao') | translate}}</span>
    </button>
  </div> -->
  <!-- Cấu hình cơ bản -->
  <!-- <ng-container *ngIf="configMode == 'basic'">
    <div style="margin-top: 10px">
      <ng-container >
        <nz-radio-group [(ngModel)]="radioValue">
          <label nz-radio nzValue="location">Nhập địa chỉ </label>
          <label nz-radio nzValue="iframe">Dùng thẻ nhúng</label>
        </nz-radio-group>
        <div class="container-font" *ngIf="radioValue == 'location'">
          <div class="config-text" style="width:100%">
            <mat-form-field style="width:100%">
              <mat-label>Nhập địa chỉ </mat-label>
              <textarea matInput [(ngModel)]="staticdata.local" (blur)="getLocal(staticdata.local)" ></textarea>
            </mat-form-field>
          </div>
        </div>
        <div *ngIf="radioValue == 'iframe'" class="map__item--change-link">
          <div>
            <input #myInput nz-input [placeholder]="placeHolder" [ngClass]="{'invalid':wrong}"
              class="input_iframe form-group" nzSize="large" [(ngModel)]="srcInput" />
          </div>
          <div class="map__item--change-link--button d-flex flex-column">
            <button class="mb-1 buttons-map" style="  background-color: white !important;
          border : 2px solid #00a859;
          color: #00a859;" nz-button nzType="primary" (click)="showModal()">
              <span style="line-height:15px; white-space: normal">Hướng dẫn chèn bản đồ</span>
            </button>
            <button nz-button nzType="primary" (click)="getLink(srcInput)">CẬP NHẬT</button>
          </div>
        </div>
      </ng-container>
    </div>
  </ng-container> -->

  <div class="editor-header" *ngIf="isViewAll">
    <i class="bi bi-chevron-left" (click)="isViewAll = !isViewAll"></i>
    <span (click)="isViewAll = !isViewAll">{{ currentViewAll.title | translate }}</span>
  </div>
  <!-- <ng-container *ngIf="!isViewAll && configMode == 'advanced'"> -->
  <ng-container>
    <ul style="padding: 0" nz-menu nzMode="inline" [nzInlineCollapsed]="isCollapsed">
      <li nz-submenu nzTitle="{{'hien_thi'| translate}}" [(nzOpen)]="openMap.menu1" (nzOpenChange)="openHandler('menu1')">
        <div class="button-size m-1 mt-2">
          <!-- Lựa chọn hiển thị cho các thiết bị -->
          <app-hide-show-config [device]="device" [elementChoosing]="objectChoosing">
          </app-hide-show-config>
        </div>
      </li>
      <!-- Cấu hình tái sử dụng thiết kế-->
      
      <!-- Cấu hình hình dạng viền -->
      <li nz-submenu nzTitle="{{'kieu_vien' | translate}}" [(nzOpen)]="openMap.menu2" (nzOpenChange)="openHandler('menu2')">
        <app-borders-config [device]="device" [class]="class" [borderClass]="class['map__iframe']"
          [id_object]="objectChoosing._id" [elementChoosing]="objectChoosing">
        </app-borders-config>
        <!-- Nút mở rộng -->
        <div class="item-border my-3" style="float: right">
          <p class="m-0 title-border my-2" (click)="openViewAll(styles_field[0])">
            {{'mo_rong' | translate}} &#8594;
          </p>
        </div>
      </li>
    </ul>
  </ng-container>
  <div class="view-more" *ngIf="isViewAll">
    <div class="view_more-border" *ngIf="currentViewAll.index == 1">
      <app-borders-radius-config [device]="device" [class]="class" [borderRadiusClass]="class['map__iframe']"
        [id_object]="objectChoosing._id" [elementChoosing]="objectChoosing">
      </app-borders-radius-config>
    </div>
  </div>
</div>